import { Suspense } from 'react';
import { PersonDetailsHeader } from '@features';
import { Loader, Skeleton } from '@mantine/core';
import { PageLayout } from '@pages';
import { Outlet } from '@tanstack/react-router';
import { PersonDetailsTabs } from './components';

export const PersonDetailsPage: React.FC = () => {
  return (
    <PageLayout
      title={
        <Suspense fallback={<Loader size="xs" color="white" />}>
          <PersonDetailsHeader />
        </Suspense>
      }
    >
      <Suspense fallback={<Skeleton height={50} />}>
        <PersonDetailsTabs />
      </Suspense>
      <Outlet />
    </PageLayout>
  );
};
